import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
//import { useParams } from 'react-router-dom'
import { Panel, Message, Row, Col, ControlLabel, Input, Form, IconButton, Icon } from 'rsuite'
import { useForm } from 'react-hook-form'
import { startLoading, doneLoading } from '../../../utils/loading'
import { isValidators, requiredFiled } from '../../../utils/ValidatorUtils'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import {
  saveMasterAccountType,
  updateMasterAccountType,
} from '../../../redux/actions/masterAccountType'

export default function CommitteeEditDetailWidget(props) {
  const {
    showCommandButton,
    isEdit,
    onChangeIsEdit,
    isAddPanel,
    editData,
    onUpdateSuccess,
    onAddSuccess,
  } = props
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(props.schema)

  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    if (editData && !isAddPanel) {
      console.log('editData', editData)
      setFormSchema((state) => ({
        ...state,
        accountName: {
          ...state.accountName,
          value: editData.accountTypeName,
        },
        accountYear: {
          ...state.accountYear,
          value: editData.accountYear,
        },
        id: editData.id,
        numberOfSequence: editData.numberOfSequence,
      }))
    }
  }, [editData])

  const handleCallServiceSave = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      let response = await saveMasterAccountType(request)
      console.log('response', response)
      if (response) {
        handleOnChangeState('', formSchema.accountName.name)
        handleOnChangeState('', formSchema.accountYear.name)
        setValue(formSchema.accountName.name)
        setValue(formSchema.accountYear.name)

        onAddSuccess(response)
      } else {
        setIsError(true)
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        console.log(e?.response?.data)
        setIsError(e.response.data.errorMessage || 'ไม่สำเร็จ')
      } else {
        setIsError('ไม่สำเร็จ')
      }
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleCallServiceUpdate = async (id, request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      let response = await updateMasterAccountType(id, request)
      console.log('response', response)
      if (response) {
        onUpdateSuccess(response)
      } else {
        setIsError(true)
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        console.log(e?.response?.data)
        setIsError(e.response.data.errorMessage || 'ไม่สำเร็จ')
      } else {
        setIsError('ไม่สำเร็จ')
      }
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('data', data)

    let request = {
      accountTypeName: data.accountName,
      accountYear: data.accountYear,
    }

    if (editData && !isAddPanel) {
      request.numberOfSequence = editData.numberOfSequence
      console.log('request', request)
      handleCallServiceUpdate(editData.id, request)
    } else {
      console.log('request', request)
      handleCallServiceSave(request)
    }
  }

  const handleOnChangeState = (value, name) => {
    setFormSchema((state) => ({
      ...state,
      [name]: {
        ...state[name],
        value: value,
      },
      id: editData?.id,
      numberOfSequence: editData?.numberOfSequence,
    }))
  }

  return (
    <Panel
      shaded
      header={isAddPanel ? 'เพิ่ม' + formSchema.header : 'แก้ไข' + formSchema.header}
      collapsible
      defaultExpanded={isAddPanel ? false : true}
      ref={(section) => {
        setSection(section)
      }}
    >
      <Row>
        {formSchema.accountName && (
          <Col xs={24} sm={12} md={12} lg={12} style={{ marginTop: 10 }}>
            <ErrorMessage error={errors[formSchema.accountName.name]} />
            <ControlLabel>
              {requiredFiled(formSchema.accountName.validators, formSchema.accountName.label)}
            </ControlLabel>
            <Input
              name={formSchema.accountName.name}
              defaultValue={formSchema.accountName.value}
              value={formSchema.accountName.value}
              onChange={(value) => handleOnChangeState(value, formSchema.accountName.name)}
              inputRef={register(isValidators(formSchema.accountName.validators))}
              placeholder={'กรอก' + formSchema.accountName.label}
            />
          </Col>
        )}

        {formSchema.accountYear && (
          <Col xs={24} sm={12} md={12} lg={12} style={{ marginTop: 10 }}>
            <ErrorMessage error={errors[formSchema.accountYear.name]} />
            <ControlLabel>
              {requiredFiled(formSchema.accountYear.validators, formSchema.accountYear.label)}
            </ControlLabel>
            <Input
              name={formSchema.accountYear.name}
              defaultValue={formSchema.accountYear.value}
              value={formSchema.accountYear.value || ''}
              onChange={(value) => handleOnChangeState(value, formSchema.accountYear.name)}
              inputRef={register(isValidators(formSchema.accountYear.validators))}
              placeholder={'กรอก' + formSchema.accountYear.label}
            />
          </Col>
        )}
      </Row>

      <>
        <hr />
        {isError && <Message showIcon type="error" description={isError} />}
        <IconButton
          appearance="ghost"
          icon={
            <Icon
              appearance="ghost"
              icon={isAddPanel ? 'plus' : 'save'}
              className="bt-gost-icon-radius"
            />
          }
          onClick={handleSubmit(onSubmit)}
        >
          {isAddPanel ? 'เพิ่ม' : 'บันทึก'}
        </IconButton>
      </>
    </Panel>
  )
}
